var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBox"},[_c('Header',{ref:"Header",attrs:{"current":"souye"}}),_c('div',{staticClass:"pageBox_cen"},[_vm._l((_vm.list),function(item,index){return [_c(_vm.mapComponent[item.name],{ref:item.name,refInFor:true,tag:"component",attrs:{"list":item},on:{"goScroll":_vm.goScroll}})]})],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }